import { cn } from "../../lib/cn";

import PHONE from "../../images/new-design/about/phone.png";
import PHONE_MOBILE from "../../images/new-design/about/phone-mobile.png";
import { Button } from "../../components/button";
import { CheckStatusModal } from "../../components/check-status-modal";
import { useEffect, useState } from "react";

const Divider = () => {
  return <div className={cn(["h-[64px] w-[1px] bg-yellow mb-6"])} />;
};

function About() {
  const [isMobile, setIsMobile] = useState(window.innerWidth < 1024);
  const [isModalOpen, setIsModalOpen] = useState(false);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 1024);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <section
      className="bg-background py-10"
      id="about"
      aria-label="About League Life"
    >
      <div
        className={cn(
          "flex flex-col gap-10 items-center",
          "lg:flex-row lg:min-h-[600px]"
        )}
      >
        <div
          className={cn(["flex gap-5 w-full", "lg:w-[50%] lg:self-stretch"])}
        >
          <img
            alt="League Life app interface showcasing athlete resources"
            src={isMobile ? PHONE_MOBILE : PHONE}
            className={cn([
              "w-full h-[396px] min-w-0 object-cover",
              "lg:h-full lg:object-cover",
            ])}
            loading="lazy"
            width="auto"
            height="396"
          />

          <img
            alt="Professional athlete using League Life services"
            src={"/about/celebrity.jpg"}
            className={cn([
              "w-full h-full min-w-0 hidden object-cover",
              "lg:block",
            ])}
            loading="lazy"
            width="auto"
            height="auto"
          />
        </div>

        <div className={cn(["w-full", "lg:w-[50%]"])}>
          <h2
            className={cn([
              "text-[46px] text-center  text-black font-ppacma",
              "lg:text-[46px]",
            ])}
          >
            About
          </h2>

          <h3
            className={cn([
              "text-[46px] text-center text-yellow font-montreal",
              "font-bold",
              "lg:text-[46px]",
            ])}
          >
            League Life
          </h3>

          <div className="flex flex-col justify-center items-center w-full mt-6 lg:px-0 px-5">
            <Divider />

            <p
              className={cn([
                "text-center text-light-black",
                "font-lg font-bold font-roboto",
                "max-w-[464px]",
                "lg:font-xl",
              ])}
            >
              League Life brings trusted resources and curated experiences to
              athletes and their families, all in one place. From vetted local
              schools and healthcare providers to restaurants, wellness
              services, and social introductions, the app makes every move
              seamless and every connection meaningful.
            </p>

            <p
              className={cn([
                "text-center text-light-black",
                "font-md font-normal font-roboto",
                "max-w-[464px] mt-5",
                "lg:font-lg",
              ])}
            >
              Search, book, and connect with confidence. Every recommendation is
              vetted, and every introduction is designed to help families feel
              at home no matter where the game takes them.
            </p>

            <a
              href="https://abi38wtuwac.typeform.com/to/Q3gHPxSM"
              target="_blank"
              rel="noopener noreferrer"
              className="p-0 m-0 h-auto w-auto mt-9"
            >
              <Button aria-label="Request access to League Life">
                Request Access
              </Button>
            </a>
          </div>
        </div>
      </div>

      {/* Check Status Modal */}
      <CheckStatusModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
      />
    </section>
  );
}

export { About };
